import { track } from "../../../common/util/tealium";

const CATEGORY = "downline_profile";

const clickTrack = (section: string, action: string) => track("link", "click_action", section, CATEGORY, "", action);

// ============================================================
// ABO Info - Header
// ============================================================
export const trackCallAbo = () => clickTrack("header_phone_number", "call_abo");
export const trackCallMessage = () => clickTrack("header_phone_number", "call_message");
export const trackCallWhatsapp = () => clickTrack("header_phone_number", "call_whatsapp");
export const trackCopyPhoneNumber = () => clickTrack("header_phone_number", "copy_phone_number");
export const trackEmailAbo = () => clickTrack("header_email", "email_abo");
export const trackCopyEmail = () => clickTrack("header_email", "copy_email");
export const trackViewTheirLos = () => clickTrack("downline_profile", "view_their_los");

// ============================================================
// Toolbar
// ============================================================
export const trackTabPerformanceMetrics = () => clickTrack("downline_profile_toolbar", "tab_performance_metrics");
export const trackTabKeyInformation = () => clickTrack("downline_profile_toolbar", "tab_key_information");
export const trackTabNotes = () => clickTrack("downline_profile_toolbar", "tab_notes");
export const trackKpiSelectorOpen = () => clickTrack("downline_profile_toolbar", "kpi_selector_open");
export const trackKpiSelectorSaveSelection = () =>
  clickTrack("downline_profile_toolbar", "kpi_selector_save_selection");
export const trackKpiSelectorClose = () => clickTrack("downline_profile_toolbar", "kpi_selector_close");

// ============================================================
// Performance Metrics Tab
// ============================================================
export const trackCustomizeKpiModalOpen = () => clickTrack("performance_metrics_tab", "customize_kpi_modal_open");
export const trackGraphView = () => clickTrack("performance_metrics_tab", "graph_view");
export const trackTableView = () => clickTrack("performance_metrics_tab", "table_view");
export const trackKpiRawDataCollapse = (kpiName: string, action: "expand" | "collapse") =>
  clickTrack("performance_metrics_tab", `${kpiName}_${action}`);
export const trackSelectPerformanceYear = (year: number) => clickTrack("performance_metrics_tab", `select_py_${year}`);

// ============================================================
// Export - open trigger (lives on the profile toolbar/overview)
// ============================================================
export const trackExportModalOpen = () => clickTrack("downline_profile", "export_modal_open");

// ============================================================
// Key Information - Applicants
// ============================================================
export const trackPrimaryApplicantCall = () => clickTrack("applicants_tile", "primary_applicant_call");
export const trackPrimaryApplicantMessage = () => clickTrack("applicants_tile", "primary_applicant_message");
export const trackPrimaryApplicantWhatsapp = () => clickTrack("applicants_tile", "primary_applicant_whatsapp");
export const trackPrimaryApplicantEmail = () => clickTrack("applicants_tile", "primary_applicant_email");
export const trackCoApplicantCall = () => clickTrack("applicants_tile", "co_applicant_call");
export const trackCoApplicantMessage = () => clickTrack("applicants_tile", "co_applicant_message");
export const trackCoApplicantWhatsapp = () => clickTrack("applicants_tile", "co_applicant_whatsapp");
export const trackCoApplicantEmail = () => clickTrack("applicants_tile", "co_applicant_email");
export const trackApplicantViewMore = () => clickTrack("applicants_tile", "applicant_view_more");
// ============================================================
// Key Information - Sponsors
// sponsorType example values: "sponsor", "platinum_sponsor", "foster_sponsor", "international_sponsor"
// ============================================================
export const trackSponsorCall = (sponsorType: string) => clickTrack("sponsors_tile", `${sponsorType}_call`);
export const trackSponsorMessage = (sponsorType: string) => clickTrack("sponsors_tile", `${sponsorType}_message`);
export const trackSponsorEmail = (sponsorType: string) => clickTrack("sponsors_tile", `${sponsorType}_email`);
export const trackSponsorWhatsapp = (sponsorType: string) => clickTrack("sponsors_tile", `${sponsorType}_whatsapp`);

// ============================================================
// Notes
// ============================================================
export const trackAddNewNote = () => clickTrack("notes_tab", "add_new_note");
export const trackSaveNote = () => clickTrack("notes_tab", "save_note");
export const trackCancelNoteChanges = () => clickTrack("notes_tab", "cancel_note_changes");
export const trackEditNote = () => clickTrack("notes_tab", "edit_note");
export const trackDeleteNoteModalOpen = () => clickTrack("notes_tab", "delete_note_modal_open");
export const trackDeleteNote = () => clickTrack("notes_modal", "delete_note");
export const trackCloseNotesModal = () => clickTrack("notes_modal", "close_modal");

// ============================================================
// Export
// ============================================================
export const trackDownloadExport = () => clickTrack("export_modal", "download_export");
export const trackCloseExportModal = () => clickTrack("export_modal", "close_modal");

// ============================================================
// Lineage
// ============================================================
export const trackSelectDownline = () => clickTrack("los_lineage_modal", "select_downline");
export const trackLineageModalToggle = (state: "open" | "close") => clickTrack("los_lineage_modal", `${state}_modal`);
export const trackLineageDownlineContact = (method: "call" | "message" | "whatsapp") =>
  clickTrack("los_lineage_modal", `${method}__downline`);

// ============================================================
// Profile Overview
// ============================================================
export const trackCloseProfile = () => clickTrack("downline_profile", "close_profile");
export const trackBackProfile = () => clickTrack("downline_profile", "back_profile");

/** Page view fired once when the Downline Profile modal finishes loading */
export const trackDownlineProfileView = () => track("view", "", "performance_metrics_tab", CATEGORY, CATEGORY, "");

/**
 * Fired from wherever a link to open the Downline Profile modal is clicked.
 * @param pageWhereLinkIsClicked path the link was clicked from, e.g. "/rwlos.html", "/renewals-action-report.html"
 */
export const trackOpenDownlineProfile = (pageWhereLinkIsClicked: string) =>
  clickTrack(pageWhereLinkIsClicked, "open_downline_profile");

// ============================================================
// KPI Selection - fired once per KPI, after the "Apply" button is clicked
// kpiName example values: "personalPV", "groupPV"
// ============================================================
export const trackKpiSelectionAdded = (kpiName: string) => clickTrack("kpi_selection_added_kpi", kpiName);
export const trackKpiSelectionRemoved = (kpiName: string) => clickTrack("kpi_selection_removed_kpi", kpiName);
